import React from 'react';

import { connect } from 'react-redux';

import { Box, RadioGroup } from '@nerdwallet/currency';
import { creditScoreRanges } from '@nerdwallet/mortgage-utils/rate-adjustment';

import { HOME_AFFORDABILITY } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import {
  inputsSelector,
  manualInputsSelector,
  hasLinkedCreditScoreSelector,
} from '../../../lib/selectors/home-affordability-calculator-selectors';
import {
  CREDIT_SCORE_ANALYTICS_HASH_VALUE,
  HomeAffordabilityInput,
  inputOnChange,
  INPUT_TRACKING_TYPES,
} from '../../../lib/utils';
import CreditScoreOnboardingCta from '../../credit-score-onboarding-cta/credit-score-onboarding-cta';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

type Props = HomeAffordabilityInput & {
  closeOnboardingModal?: () => void;
};

const CreditScoreInput: React.FC<Props> = ({
  inputs,
  manualInputs,
  dispatch,
  analytics,
  hasLinkedCreditScore,
  closeOnboardingModal,
}) => {
  const value =
    manualInputs?.creditScoreRangeValue || hasLinkedCreditScore
      ? inputs?.creditScoreRangeValue
      : null;

  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'creditScoreRangeValue',
        inputType: INPUT_TRACKING_TYPES.RANGE,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
        mapValue: (target: string) =>
          CREDIT_SCORE_ANALYTICS_HASH_VALUE[target] || null,
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'creditScoreRangeValue',
      calculator: HOME_AFFORDABILITY,
      validate: false,
    });
  };

  const showCta = inputs?.creditScoreRangeValue && !hasLinkedCreditScore;

  return (
    <React.Fragment>
      <RadioGroup
        value={value}
        options={creditScoreRanges}
        onChange={onInputChange}
      />
      {showCta && (
        <Box marginTop={2}>
          <CreditScoreOnboardingCta
            closeOnboardingModal={closeOnboardingModal}
          />
        </Box>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  inputs: inputsSelector(state),
  manualInputs: manualInputsSelector(state),
  validations: validationsSelector(state),
  hasLinkedCreditScore: hasLinkedCreditScoreSelector(state),
});

export default connect(mapStateToProps)(CreditScoreInput);
